/* eslint-disable react-hooks/exhaustive-deps */
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons"
import { faStar } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, withRouter } from "react-router"
import { Link } from "react-router-dom"
import { AppDispatch } from "../.."
import { T分類, 分類リスト } from "../../constant/categories"
import constants from "../../constant/constant"

import { allPages, TPage } from "../../constant/pages"
import { addMyMenu, deleteMyMenu } from "../../globalStore/menuStore"
import { RootState } from "../../globalStore/rootreducer"
import util from "../../ts/util"
import classes from "./PageList.module.scss"

const PageList = () => {
  // 本来は名前が必須
  const myPages = useSelector((state: RootState) => state.menu.myPages)
  const menus = useSelector((state: RootState) => state.menu.menuPage)

  const dispatch: AppDispatch = useDispatch()

  const Location = useLocation()
  // const history = useHistory()

  // カテゴリ単位でのページ抽出
  const [displayPages, setDisplayPages] = useState<TPage[]>()
  const [display分類, setDisplay分類] = useState<T分類>()

  useEffect(() => {
    const 分類 = 分類リスト.find((d) => d.url === Location.pathname)
    if (分類 != null) {
      setDisplay分類(分類)
      const pageList = allPages.filter(
        (m) =>
          m.分類コード === 分類.分類コード &&
          (m.メニュー表示フラグ ?? true) &&
          menus.find((ms) => ms.メニューコード === m.メニューコード)
      )

      pageList && setDisplayPages([...pageList])
      // ページタイトルを設定
      document.title =
        `${constants.APP_NAME} - 大川運輸 - ` + 分類.分類名 + "メニュー一覧"
    }
  }, [Location.pathname, menus])

  const bookMarkToggle = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    メニューコード: string
  ) => {
    e.stopPropagation()
    let isFavorite = myPages.find((p) => p.メニューコード === メニューコード)
    if (isFavorite) {
      dispatch(deleteMyMenu({ メニューコードリスト: [メニューコード] }))
    } else {
      dispatch(addMyMenu({ メニューコードリスト: [メニューコード] }))
    }
  }
  return (
    <Container fluid>
      <div>
        <Row>
          <Col className={classes.middle1CategoryName}>
            {display分類?.分類名}
          </Col>
        </Row>
        <Row>
          <Col className={classes.pageListCardContainer}>
            {displayPages?.map((メニュー: TPage, j: number) => {
              const path = util.getDefaultPath(メニュー.Route)
              const dbメニュー = menus.find(
                (m) => m.メニューコード === メニュー.メニューコード
              )

              return (
                <Link key={`${メニュー.メニューコード}_${j}`} to={path}>
                  <Card className={classes.pageListCard}>
                    <div className={classes.pageListCardHeader}>
                      <div className={classes.pageListCardTitle}>
                        <span className={classes.pageListCardTitleInner}>
                          {メニュー.機能名}
                        </span>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          bookMarkToggle(e, メニュー.メニューコード)
                        }}
                        className={classes.pageListCardBookmark}>
                        <span className={classes.pageListFavoriteIcon}>
                          <FontAwesomeIcon
                            icon={
                              myPages.find(
                                (m) =>
                                  m.メニューコード === メニュー.メニューコード
                              )
                                ? faStar
                                : farStar
                            }
                          />
                        </span>
                      </div>
                    </div>
                    <Card.Body className={classes.pageListCardBody}>
                      {dbメニュー != null && dbメニュー.機能説明文}
                    </Card.Body>
                  </Card>
                </Link>
              )
            })}
          </Col>
        </Row>
      </div>
    </Container>
  )
}

export default withRouter(PageList)
